import { RouteType } from "types/RouteType";

/**
 * Earning Profiles Route
 * Manage earning profile templates for payroll
 */
export const earningProfilesRoute: RouteType = {
  name: "Earning Profiles",
  path: "/payroll/admin/earning-profiles",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Earning Profiles",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./earnings/EarningProfiles.Header"),
    },
    body: {
      component: () => import("./earnings/EarningProfiles.Body"),
      grayBackground: true,
    },
  },
  dialogs: [
    {
      name: "EarningProfileDialog",
      title: "Earning Profile",
      component: () => import("./earnings/EarningProfileDialog"),
    },
    {
      name: "EarningLineItemDialog",
      title: "Earning Type",
      component: () => import("./earnings/EarningLineItemDialog"),
    },
  ],
  group: "Payroll Admin",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async () => {
    return true;
  },
};

/**
 * Deduction Profiles Route
 * Manage deduction profile templates for payroll
 * KEY FEATURE: Single deduction code routes to different GLs based on employee type
 */
export const deductionProfilesRoute: RouteType = {
  name: "Deduction Profiles",
  path: "/payroll/admin/deduction-profiles",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Deduction Profiles",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./deductions/DeductionProfiles.Header"),
    },
    body: {
      component: () => import("./deductions/DeductionProfiles.Body"),
      grayBackground: true,
    },
  },
  dialogs: [
    {
      name: "DeductionProfileDialog",
      title: "Deduction Profile",
      component: () => import("./deductions/DeductionProfileDialog"),
    },
    {
      name: "DeductionLineItemDialog",
      title: "Deduction Type",
      component: () => import("./deductions/DeductionLineItemDialog"),
      fullWidth: true,
    },
  ],
  group: "Payroll Admin",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async () => {
    return true;
  },
};

export default [earningProfilesRoute, deductionProfilesRoute];
